import PropTypes from 'prop-types';

import Header from 'UI/Screens/Main/Sections/Header/Header';
import AboutUs from 'UI/Screens/Main/Sections/AboutUs/AboutUs';
import Services from 'UI/Screens/Main/Sections/Services/Services';
import Partners from 'UI/Screens/Main/Sections/Partners/Partners';
import Contact from 'UI/Screens/Main/Sections/Contact/Contact';

const MainScreen = ({
  branchLocationOptions,
}) => {
  return (
    <>
      <Header branchLocationOptions={branchLocationOptions} />
      <AboutUs />
      <Services />
      <Partners />
      <Contact />
    </>
  );
}

MainScreen.propTypes = {
  branchLocationOptions: PropTypes.object,
};

export default MainScreen;
